/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-empty-function */
import { createContext } from "react";
import constants from "../constants";

const { USER, JWT, IS_LOGGED_IN, IS_WHATSAPP_BUBBLE } = constants.state;

const file = { id: 0, name: "", url: "" };

const user = {
  id: 0,
  username: "",
  email: "",
  firstName: "",
  lastName: "",
  phone: "",
  firebaseToken: "",
  googleId: "",
  facebookId: "",
  appleId: "",
  isVendor: false,
  isAgency: false,
  agency: {
    id: 0,
    name: "",
    rnt: "",
    procedureRnt: "",
    managerFirstName: "",
    managerLastName: "",
    country: "",
    state: "",
    city: "",
    address: "",
    localPhone: "",
    phone: "",
    postalCode: "",
    documents: {
      id: 0,
      authorizationLetter: file,
      constitutiveAct: file,
      domicile: file,
      fiscalSituation: file,
      notarialPower: file,
      officialIdentification: file,
      rnt: file,
      requiresInvoice: null,
    },
  },
  documents: {
    id: 0,
    fiscalSituation: file,
    domicile: file,
    officialIdentification: file,
    requiresInvoice: null,
  },
  photo: file,
  missingAgencyData: false,
  missingAgencyDocuments: false,
  missingDocuments: false,
};

const initialState = {
  user,
  jwt: "",
  isLoggedIn: false,
  isWhatsappBubble: false,
};

const StateContext = createContext({
  updateUser: (user = {}) => {},
  updateJwt: (jwt = "") => {},
  updateIsLoggedIn: (isLoggedIn = false) => {},
  updateIsWhatsappBubble: (isWhatsappBubble = false) => {},
  refreshUser: async () => {},
  ...initialState,
});

const stateReducer = (prevState, action) => {
  switch (action.type) {
    case USER:
      return {
        ...prevState,
        user: action.user,
      };
    case JWT:
      return {
        ...prevState,
        jwt: action.jwt,
      };
    case IS_WHATSAPP_BUBBLE:
      return {
        ...prevState,
        isWhatsappBubble: action.isWhatsappBubble,
      };
    case IS_LOGGED_IN:
      if (action.isLoggedIn) {
        return {
          ...prevState,
          isLoggedIn: true,
        };
      } else {
        localStorage.removeItem(JWT);
        sessionStorage.removeItem(JWT);
        return {
          ...prevState,
          ...initialState,
        };
      }
    default:
      return prevState;
  }
};

export { initialState, StateContext, stateReducer };
